var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLibraryTabActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22268_205112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.84969V16.7397C22.5 17.7097 21.71 18.5997 20.74 18.7197L20.43 18.7597C18.79 18.9797 16.48 19.6597 14.62 20.4397C13.97 20.7097 13.25 20.2197 13.25 19.5097V5.59969C13.25 5.22969 13.46 4.88969 13.79 4.70969C15.62 3.71969 18.39 2.83969 20.27 2.67969H20.33C21.53 2.67969 22.5 3.64969 22.5 4.84969Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2102 4.70969C9.38023 3.71969 6.61023 2.83969 4.73023 2.67969H4.66023C3.46023 2.67969 2.49023 3.64969 2.49023 4.84969V16.7397C2.49023 17.7097 3.28023 18.5997 4.25023 18.7197L4.56023 18.7597C6.20023 18.9797 8.51023 19.6597 10.3702 20.4397C11.0202 20.7097 11.7402 20.2197 11.7402 19.5097V5.59969C11.7402 5.21969 11.5402 4.88969 11.2102 4.70969ZM5.50023 7.73969H7.75023C8.16023 7.73969 8.50023 8.07969 8.50023 8.48969C8.50023 8.90969 8.16023 9.23969 7.75023 9.23969H5.50023C5.09023 9.23969 4.75023 8.90969 4.75023 8.48969C4.75023 8.07969 5.09023 7.73969 5.50023 7.73969ZM8.50023 12.2397H5.50023C5.09023 12.2397 4.75023 11.9097 4.75023 11.4897C4.75023 11.0797 5.09023 10.7397 5.50023 10.7397H8.50023C8.91023 10.7397 9.25023 11.0797 9.25023 11.4897C9.25023 11.9097 8.91023 12.2397 8.50023 12.2397Z",
    fill: "#0C66E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22268_205112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryTabActive);
export default __webpack_public_path__ + "static/media/libraryTabActive.70dd5cadbab461e90925212c6a0c6378.svg";
export { ForwardRef as ReactComponent };